import { LOGIN_HOST } from '../externals'
import { LoginService } from './LoginService'

export const getLoginServiceForApp = () => new LoginService(LOGIN_HOST)
